module.exports = __webpack_public_path__ + "static/media/work-antic.35bd51ca.jpg";